<script setup lang="ts">
import { BalloonTableItem } from '@/store/delivery/delivery.types'

type Props = {
  data: BalloonTableItem
}

defineProps<Props>()
</script>

<template>
  <tr class="balloon-table-row">
    <td class="balloon-table-row__label">{{ data.label }}</td>
    <td class="balloon-table-row__value">{{ data.value }}</td>
  </tr>
</template>

<style lang="scss" scoped>
.balloon-table-row {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  font-size: 12px;
  line-height: 14px;

  &__label {
    font-weight: 500;
  }

  &__value {
    font-weight: 800;
    text-align: right;
  }
}
</style>
